import { BlogTypes, TBlog } from "components/Blog/Blog.types";
import { Button, Pill, Icon } from "shared";
import IconComponent, { IconName } from "shared/IconComponent/IconComponent";

export type TBlogItemProps = {
  blog: TBlog;
  ctaText?: string;
};

const MAX_TAGS_DISPLAYED = 2;

function BlogItem({ blog, ctaText }: TBlogItemProps) {
  const noOfTags = blog?.Tags.length;

  const goToBlogPage = () => {
    window.location.href = blog.Url;
  };

  const colorCssClassName = {
    [BlogTypes.Blog]: "",
    [BlogTypes.Event]: "m-blog-item__type--blue",
    [BlogTypes.News]: "m-blog-item__type--purple",
  };

  return (
    <div className="m-blog-item">
      <img
        onClick={goToBlogPage}
        className="m-blog-item__image"
        alt={blog?.Title}
        loading="lazy"
        src={blog.ImageUrl}
      />
      <div className="m-blog-item__content">
        <div className="m-blog-item__row">
          <div className="m-blog-item__tags">
            {blog?.Tags.slice(0, MAX_TAGS_DISPLAYED).map((tag, idx) => (
              <Pill text={tag} color="dark" key={`blog-${blog.Id}-${idx}`} />
            ))}
            {noOfTags > MAX_TAGS_DISPLAYED && (
              <Pill text={`+${noOfTags - MAX_TAGS_DISPLAYED}`} color="dark" />
            )}
          </div>
          <div className="m-blog-item__date">{blog.Date}</div>
        </div>
        <a href={blog.Url} className="m-blog-item__title">
          {blog.Title}
        </a>
        <div className="m-blog-item__description">{blog.Description}</div>
        <div className="m-blog-item__row">
          <Button
            text={ctaText || "Read more"}
            onClick={goToBlogPage}
            type="link"
            startIcon={<Icon name={IconName.RightArrow} />}
          />
          <div className="m-blog-item__row m-blog-item__read">
            <Icon name={IconName.Clock} />
            <span>{blog.ReadTime}</span>
          </div>
        </div>
      </div>
      <div
        className={`m-blog-item__type ${colorCssClassName[blog.Type] || ""}`}
      >
        {blog.Type}
      </div>
      {blog?.FeaturedText && (
        <div className="m-blog-item__featured">
          <span>{blog?.FeaturedText}</span>
          <IconComponent name={IconName.Star} />
        </div>
      )}
    </div>
  );
}

export default BlogItem;
